// Implements: F-UIX-019
/**
 * The route guard of the platform admin's views (UIX.8: "unreachable for other roles").
 *
 * It sits inside `RequireSession`, so a session is already there. It follows the server's
 * permission answer on the platform scope (UIX.5, `opensPlatformView`), never a role name:
 * anybody the server answers none of the platform actions gets the not-found page, the same one
 * an unknown address shows (the server answers the platform reads with the `404` of a path that
 * does not exist, too), and the views below are never mounted, so nothing is read for them.
 */

import type { ReactElement } from "react";
import { Outlet } from "react-router";

import { opensPlatformView } from "../../modules/admin/model/platformAccess";
import { useSession } from "../../shared/api/session";
import { NotFoundPage } from "../pages/NotFoundPage";

/** Where the platform admin's views live (`ROUTE_PATHS.platformAdmin`); the header links here. */
export const PLATFORM_ADMIN_PATH = "/admin";

export function RequirePlatformAdmin(): ReactElement {
  const { state } = useSession();
  if (state.status !== "authenticated" || !opensPlatformView(state.view.scopes)) return <NotFoundPage />;
  return <Outlet />;
}
